import React from "react";
// UI Framework
import AddIcon from "@mui/icons-material/Add";

interface Props {
  onClick: () => void;
}

const AddButton: React.FC<Props> = ({ onClick }) => {
  return (
    <div
      className="bg-sky-600 rounded-full flex justify-center items-center w-11 h-11 cursor-pointer absolute top-10 left-5"
      onClick={(e) => {
        onClick();
        e.stopPropagation();
      }}
    >
      <AddIcon className="text-white" data-testid="add-button" />
    </div>
  );
};

export default AddButton;
